import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Card, Row } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  border: '2px solid #707070',
  boxShadow: 24,
  p: 4,
};

function PreviewModal({
  visible = false,
  onClose = () => {},
  calculationData = {},
  loading = false,
  onFinish = () => {},
}) {
  const { addedUserList } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
    };
  });
  return (
    <Modal
      open={visible}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={style}
        style={{ overflowY: 'auto' }}
      >
        <Row
          style={{
            justifyContent: 'center',
          }}
        >
          <Typography
            style={{
              fontWeight: 'bold',
            }}
            variant='h6'
          >
            Order Summary
          </Typography>
        </Row>
        {calculationData?.ship_to_parties_info?.map((stp) => {
          const stpDetails = addedUserList.find(
            (item) =>
              item.company_id === stp.ship_to_party_info.deliver_to &&
              item.delivery_company_pincode === stp.ship_to_party_info.pincode &&
              item?.delivery_Address_line1 === stp.ship_to_party_info?.delivery_address?.address_line_1 &&
              item?.delivery_Address_line2 === stp.ship_to_party_info?.delivery_address?.address_line_2 &&
              item?.delivery_Address_line3 === stp.ship_to_party_info?.delivery_address?.address_line_3
          );
          return (
            <>
              {stpDetails && (
                <Card
                  title={stpDetails?.company_name}
                  style={{
                    marginTop: 20,
                    borderRadius: 10,
                    borderColor: '#c5c5c5',
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    style={{
                      marginLeft: 10,
                      marginRight: 10,
                    }}
                    gap={4}
                  >
                    {[
                      {
                        label: stpDetails?.gstin
                          ? 'Company GSTIN'
                          : 'Company PAN',
                        value: stpDetails?.gstin ? 'gstin' : 'pancard_no',
                      },
                      {
                        label: 'Company Phone',
                        value: 'company_phone_no',
                      },
                    ].map((vv) => (
                      <Grid
                        size={8}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        {' '}
                        <Typography
                          style={{
                            fontWeight: 'bold',
                            marginRight: 5,
                          }}
                        >
                          {vv.label}:
                        </Typography>{' '}
                        {stpDetails[vv.value]}
                      </Grid>
                    ))}
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    style={{
                      marginLeft: 10,
                      marginRight: 10,
                      marginTop: 10,
                    }}
                    gap={4}
                  >
                    {[
                      {
                        label: 'Delivery Address Line 1',
                        value: 'delivery_Address_line1',
                      },
                      {
                        label: 'Delivery Address Line 2',
                        value: 'delivery_Address_line2',
                      },
                      {
                        label: 'Delivery Address Line 3',
                        value: 'delivery_Address_line3',
                      },
                      {
                        label: 'Delivery Pincode',
                        value: 'delivery_company_pincode',
                      },
                    ].map((vv) => (
                      <Grid
                        size={8}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        {' '}
                        <Typography
                          style={{
                            fontWeight: 'bold',
                            marginRight: 5,
                          }}
                        >
                          {vv.label}:
                        </Typography>{' '}
                        {stpDetails[vv.value]}
                      </Grid>
                    ))}
                  </Grid>

                  {/* STP Products */}

                  <Typography
                    sx={{ marginTop: 5 }}
                    variant='h6'
                  >
                    Product Details
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table
                      sx={{ minWidth: 650 }}
                      aria-label='simple table'
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Typography style={{ fontWeight: 'bold' }}>
                              Product Name
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography style={{ fontWeight: 'bold' }}>
                              Quantity
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography style={{ fontWeight: 'bold' }}>
                              Unit
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {stp?.products_summary_info?.map((row) => (
                          <TableRow
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                            }}
                          >
                            <TableCell>
                              <Typography>{row.product_name}</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography>
                                {row.quantity.quantity_in_metric_ton}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography>{row.quantity.unit}</Typography>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
              )}
            </>
          );
        })}

        <Card
          title='Total Cart Value'
          style={{
            marginTop: 20,
            borderRadius: 10,
            borderColor: '#c5c5c5',
          }}
        >
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              aria-label='simple table'
            >
              <TableHead>
                <TableRow>
                  {calculationData?.order_summary_info?.total_bill_info?.map(
                    (cell) => (
                      <TableCell>
                        <Typography
                          style={{
                            fontWeight: 'bold',
                          }}
                        >
                          {cell.display_name}
                        </Typography>
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                >
                  {calculationData?.order_summary_info?.total_bill_info?.map(
                    (row) => (
                      <TableCell>
                        <Typography>{row.label}</Typography>
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

        <Row>
          <Button
            variant='contained'
            onClick={() => {
              onFinish();
            }}
            sx={{
              fontWeight: 'bold',
              width: 200,
              marginLeft: 'auto',
              marginTop: 3,
            }}
            disabled={loading}
            startIcon={
              loading && (
                <CircularProgress
                  sx={{ color: 'white' }}
                  size={20}
                />
              )
            }
          >
            {loading ? 'Loading...' : 'Checkout'}
          </Button>
        </Row>
      </Box>
    </Modal>
  );
}

export default PreviewModal;
